import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 30000 });
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("mb_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    if (err.response?.status === 401 && !err.config?.url?.includes("/auth/login")) {
      localStorage.removeItem("mb_token");
      window.dispatchEvent(new Event("mb-logout"));
    }
    const cfg = err.config || {};
    const transient = !err.response || [502, 503, 504].includes(err.response?.status);
    if (transient && String(cfg.method || "get").toLowerCase() === "get" && !cfg.__mbRetried) {
      cfg.__mbRetried = true;
      await new Promise((resolve) => setTimeout(resolve, 700));
      return api(cfg);
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join("; ");
  return d.msg || JSON.stringify(d);
}

export async function downloadExport(id, filename) {
  const res = await api.get(`/exports/${id}/download`, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "prospects.xlsx";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "—");
export const fmtDay = (iso) => (iso ? new Date(iso).toLocaleDateString("en-IN", { dateStyle: "medium" }) : "—");
